import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import '../../assets/css/style.css';
import HedDan from "./Header";
import BackArow from '../../assets/img/back.svg';

const AddBankDan = () => {
  const navigate = useNavigate();
  const [shaba, setShaba] = useState("");
  const [bankName, setBankName] = useState("");
  const [ownerName, setOwnerName] = useState(""); // قابل ویرایش توسط کاربر
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!shaba) {
      alert("لطفاً شماره شبا را وارد کنید.");
      return;
    }




    setLoading(true);
    const token = localStorage.getItem("donetoken");

    try {
      const response = await fetch("https://app.doneapp.ir/backend/add_bank_info.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          token: token,
          user_shaba: shaba,
        }), // نام کاربر را ارسال نمی‌کنیم چون از جیبت دریافت می‌شود
      });

      const data = await response.json();

      if (data.status === "success") {
        setBankName(data.bank_name);
        console.log(data);

        alert("✅ اطلاعات حساب با موفقیت ثبت شد.");
        setTimeout(() => navigate("/panel/cards"), 1500); // بعد از 1.5 ثانیه هدایت شود
      } else {
        alert("❌ خطا: " + data.message);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("خطایی رخ داده است.");
    }

    setLoading(false);
  };

  return (
    <>
      <HedDan />
      <div className="mohtava-mine">
        <section id="add-bank" className="dir-r max-cntt-w v-100">
          <div className="reflist-div-1 mt-30">
            <div className="d-flex">
              <p className="reflist-p-1" onClick={() => navigate("/panel/cards")}>
                افزودن حساب بانکی
              </p>
              <img src={BackArow} className="reflist-img-1" alt="back" onClick={() => navigate("/panel/cards")} />
            </div>
          </div>

          <div className="addbank-input-div">
            {/* نام صاحب حساب قابل ویرایش است ولی در پردازش استفاده نمی‌شود */}
            <input
              type="text"
              className="addbank-input-1"
              placeholder="نام صاحب حساب را وارد کنید"
              value={ownerName}
              onChange={(e) => setOwnerName(e.target.value)}
            />

            <div className="addbank-input-div-2">
              <input
                type="text"
                className="addbank-input-2"
                placeholder="شماره شبا را اینجا وارد کنید"
                value={shaba}
                onChange={(e) => setShaba(e.target.value)}
              />
              <span className="addbank-ir">IR</span>
            </div>
          </div>

          {bankName && (
            <div className="bank-info">
              <p>🏦 بانک: {bankName}</p>
            </div>
          )}

          <div className="addbank-div-2">
            <button className="gift-ref-btn-1" onClick={handleSubmit} disabled={loading}>
              {loading ? "در حال بررسی..." : "ثبت مشخصات حساب"}
            </button>

            <button onClick={() => navigate("/panel/cards")} className="cancel-btn-1">
              انصراف
            </button>
          </div>

          <div className="p-35">
            <ul>
              <li>جهت جلوگیری از بروز مشکل از نام شناسنامه‌ای صاحب حساب استفاده نمایید.</li>
              <li>شماره‌ی شبا را بدون وارد نمودن دو حرف IR در ابتدا وارد نمایید.</li>
              <li>امکان واریز تنها به نام شما و به شماره حساب منطبق با کد ملی شما صورت می‌پذیرد.</li>
            </ul>
          </div>
        </section>
      </div>
    </>
  );
};

export default AddBankDan;
